import { ContentBlock } from "../../types/contentBlock";
import { LogoSlider } from "../../types/logoSlider";

export const isLogoSlider = (solution: ContentBlock): solution is LogoSlider => {
    return solution._type === 'logoSlider';
}